import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOutboundsGroupParams, TypePostOutboundsGroupResponse } from '~/types/delivery-agency.types';

/**
 * [합포 단위 관리] 합포장 API
 */
const fetchPostOutboundsGroup = async (
  params: TypePostOutboundsGroupParams
): Promise<TypePostOutboundsGroupResponse['data']> => {
  const { data } = await axiosInstance.post<TypePostOutboundsGroupResponse>(
    API_ENDPOINT.DELIVERY_AGENCY.POST_OUTBOUNDS_GROUP,
    params
  );
  return data.data;
};

/**
 * [합포 단위 관리] 합포장 Mutation Hook
 */
export const usePostOutboundsGroupMutation = () => {
  return useMutation<
    TypePostOutboundsGroupResponse['data'],
    TypeErrorResponseData['error'],
    TypePostOutboundsGroupParams
  >({
    mutationFn: fetchPostOutboundsGroup,
    meta: { silent: true },
  });
};
